import StandardTable from './StandardTable';

export default StandardTable;
